import { render, staticRenderFns } from "./indicador-de-atividade.vue?vue&type=template&id=68098e34&scoped=true&"
import script from "./indicador-de-atividade.vue?vue&type=script&lang=js&"
export * from "./indicador-de-atividade.vue?vue&type=script&lang=js&"
import style0 from "./indicador-de-atividade.vue?vue&type=style&index=0&id=68098e34&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68098e34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68098e34')) {
      api.createRecord('68098e34', component.options)
    } else {
      api.reload('68098e34', component.options)
    }
    module.hot.accept("./indicador-de-atividade.vue?vue&type=template&id=68098e34&scoped=true&", function () {
      api.rerender('68098e34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/indicador-de-atividade/indicador-de-atividade.vue"
export default component.exports